export default "__VITE_ASSET__CSW0GQYL__"